import { apiSlice } from './apiSlice';
import type { LiveAsset, LiveAssetReservation } from '../types/inventory';

export const liveAssetsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLiveAssets: builder.query<LiveAsset[], { saveId: string }>({
      query: ({ saveId }) => ({ url: `/saves/${saveId}/live-assets` }),
      transformResponse: (resp: { assets: LiveAsset[] }) => resp.assets ?? [],
      providesTags: [{ type: 'LiveAsset', id: 'LIST' }],
    }),

    getLiveAssetReservations: builder.query<LiveAssetReservation[], { saveId: string; plantingId?: string; status?: string }>({
      query: ({ saveId, plantingId, status }) => ({
        url: `/saves/${saveId}/live-assets/reservations`,
        params: { ...(plantingId ? { plantingId } : {}), ...(status ? { status } : {}) },
      }),
      transformResponse: (resp: { reservations: LiveAssetReservation[] }) => resp.reservations ?? [],
      providesTags: [{ type: 'LiveAsset', id: 'RESERVATIONS' }],
    }),

    reserveLiveAsset: builder.mutation<any, { saveId: string; plantingId: string; payload: { quantity: number; reason?: string; counterpartyRef?: string } }>({
      query: ({ saveId, plantingId, payload }) => ({
        url: `/saves/${saveId}/live-assets/${plantingId}/reserve`, method: 'POST', body: payload,
      }),
      invalidatesTags: [{ type: 'LiveAsset', id: 'LIST' }, { type: 'LiveAsset', id: 'RESERVATIONS' }],
    }),

    releaseLiveAssetReservation: builder.mutation<any, { saveId: string; reservationId: string }>({
      query: ({ saveId, reservationId }) => ({
        url: `/saves/${saveId}/live-assets/reservations/${reservationId}/release`, method: 'POST', body: {},
      }),
      invalidatesTags: [{ type: 'LiveAsset', id: 'LIST' }, { type: 'LiveAsset', id: 'RESERVATIONS' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetLiveAssetsQuery,
  useGetLiveAssetReservationsQuery,
  useReserveLiveAssetMutation,
  useReleaseLiveAssetReservationMutation,
} = liveAssetsApi;

export default liveAssetsApi;
